import { useContext } from "react";
import { MainContext } from "../layouts/Main";

export default function useMainContext() {
  return useContext(MainContext);
}
